export default __webpack_public_path__ + "static/media/pos1.c6ad4c6d.png";